import React from 'react'
import Navbar from '../../components/Navbar'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import { StyledLink } from './../../components/StyledComponents';
import icon_arrow_right from "../../assets/images/icons/arrow_24px_right.svg"
import icon_qr_code from "../../assets/images/icons/qr_code_80px.svg"
import Footer from '../../components/Footer';
import IndustriesImageContainer from '../../components/IndustriesImageContainer';
import TechnologyPaginationSlick from './TechnologyPaginationSlick';
import filter_color from "../../assets/images/design/colorFilter.svg"
import icon_rocket from "../../assets/images/icons/rocket_80px.svg"
import icon_puzzle from "../../assets/images/icons/puzzle_80px.svg"
import icon_file_a from "../../assets/images/icons/file_a_80px.svg"
import icon_shield_lock from "../../assets/images/icons/shield_lock_80px.svg"
import TechnologyTab from '../../components/TechnologyTab';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';

const Technology = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    return (
        <div className='technology bg-primary'>
            <div className='color-filter-right' style={{ top: "30%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "50%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>

            <Navbar />
            <div className='container-fluid technology-header'>
                <div className='container'>
                    <div className='col-sm-12 pt-200'>
                        <p className='font-weight-bold text-center font-96 technology-header-title'>{t('technology.header')}</p>
                    </div>
                    <div className='col-sm-10 col-sm-offset-1 pt-50'>
                        <p className='text-center text-gray'>{t('technology.sub-header')}</p>
                    </div>
                    <div className='col-sm-12 flex justify-center pt-50 pb-100'>
                        <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.technologies')} />
                    </div>
                </div>
            </div>
            <TechnologyTab allTechnoActive={true} />
            <div className='technology-content container'>
                <div className='col-sm-12 pt-50'>
                    {language === "en" ?
                        <p className='font-48 font-weight-semi-bold text-white text-center'><span className='text-primary-orange'>Technologies</span> We Work With</p>
                        :
                        <p className='font-48 font-weight-semi-bold text-white text-center'><span className='text-primary-orange'>Công nghệ</span> chúng tôi làm việc cùng</p>
                    }
                </div>
                <div className='technology-card col-sm-12 px-0'>
                    <div className='row'>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/technology/overview">
                                <div className='technology-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('technology.card-title-1')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_qr_code} alt="qr_code" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('technology.card-content-1')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/technology/deployment">
                                <div className='technology-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('technology.card-title-2')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_rocket} alt="money_inscreases" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('technology.card-content-2')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/technology/integration">
                                <div className='technology-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('technology.card-title-3')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_puzzle} alt="shield_checked" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('technology.card-content-3')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/technology/generating_pdf_reports_and_documents">
                                <div className='technology-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('technology.card-title-4')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_file_a} alt="golf_goal" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('technology.card-content-4')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                        <div className='col-md-12 col-lg-6 pt-50'>
                            <StyledLink href="/technology/security">
                                <div className='technology-card_item'>
                                    <div className='flex justify-spacebetween'>
                                        <p className='font-24 text-primary-cyan'>{t('technology.card-title-5')}
                                            <span><img src={icon_arrow_right} alt='arrow_right' className='mb--5 scale-img ml-5' /></span></p>
                                        <img src={icon_shield_lock} alt="heart_broken" className='client-s-80' />
                                    </div>
                                    <div className='pt-50'>
                                        <p className='font-20 text-gray'>{t('technology.card-content-5')}</p>
                                    </div>
                                </div>
                            </StyledLink>
                        </div>
                    </div>
                </div>
                {language === "en" ?
                    <div className='col-sm-10 col-sm-offset-1 pt-50'>
                        <p className='font-weight-semi-bold font-48 text-white text-center'><span className='text-primary-orange'>Secure Encrypted</span> QR Code Generation</p>
                        <p className='text-gray text-center pt-20'>Qrypto Secure QR code technology is uniquely designed to make any physical or electronic document tamper-proof and instantly verifiable by any third party in a unique <span className='text-white font-weight-semi-bold'>server-less architecture</span>.</p>
                        <p className='text-gray text-center pt-20'>The secure QR code solution <span className='text-white font-weight-semi-bold'>easily plugs into existing document production systems</span>. It generates a <span className='text-white font-weight-semi-bold'>highly secure</span> digital signature with embedded data that is placed on the document as a QR Code. Anyone can instantly verify the credibility of the information by scanning that code with an App on their smartphone.</p>
                        <p className='text-gray text-center pt-20'>This novel architecture provides many benefits:</p>
                    </div>
                    :
                    <div className='col-sm-10 col-sm-offset-1 pt-50'>
                        <p className='font-weight-semi-bold font-48 text-white text-center'>Tạo mã QR được <span className='text-primary-orange'>mã hóa an toàn</span></p>
                        <p className='text-gray text-center pt-20'>Công nghệ mã QR Qrypto Secure được thiết kế độc đáo để giúp mọi tài liệu vật lý hoặc điện tử chống giả mạo và có thể được xác minh ngay lập tức bởi bất kỳ bên thứ ba nào trong một <span className='text-white font-weight-semi-bold'>kiến ​​trúc không có máy chủ duy nhất.</span>.</p>
                        <p className='text-gray text-center pt-20'>Giải pháp mã QR an toàn <span className='text-white font-weight-semi-bold'>dễ dàng kết nối với các hệ thống sản xuất tài liệu hiện có</span>. Nó tạo ra chữ ký số có <span className='text-white font-weight-semi-bold'>độ bảo mật cao</span> với dữ liệu nhúng được đặt trên tài liệu dưới dạng Mã QR. Bất kỳ ai cũng có thể xác minh ngay độ tin cậy của thông tin bằng cách quét mã đó bằng Ứng dụng trên điện thoại thông minh của họ.</p>
                        <p className='text-gray text-center pt-20'>Kiến trúc mới lạ này mang lại nhiều lợi ích:</p>
                    </div>
                }
                <TechnologyPaginationSlick />
                <IndustriesImageContainer />
            </div>

            <Footer />
        </div>
    )
}

export default Technology